import { FC } from 'react';

/**
 * Renderiza o avatar do agente. O campo `avatar` pode ser:
 * - um nome de Material Symbol (ex.: "psychology" — usado pelo Oráculo da Fase 1)
 * - um emoji (ex.: "🤖" — agentes PERSONAL criados pelo learner na Fase 2)
 *
 * Heurística: só ascii minúsculo/underscore => Material Symbol; senão => emoji.
 */
function isMaterialSymbolName(avatar: string): boolean {
  return /^[a-z][a-z0-9_]*$/.test(avatar);
}

interface Props {
  avatar: string;
  /** tamanho do quadrado (classes Tailwind), default w-14 h-14 */
  sizeClass?: string;
  textClass?: string;
}

const AgentAvatar: FC<Props> = ({ avatar, sizeClass = 'w-14 h-14', textClass = 'text-3xl' }) => {
  const value = avatar || 'psychology';
  return (
    <div
      className={`${sizeClass} rounded-xl bg-accent/10 border border-accent/30 flex items-center justify-center flex-shrink-0`}
    >
      {isMaterialSymbolName(value) ? (
        <span className={`material-symbols-outlined text-accent ${textClass}`}>{value}</span>
      ) : (
        <span className={textClass} aria-hidden>
          {value}
        </span>
      )}
    </div>
  );
};

export default AgentAvatar;
